import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Button } from "@/components/ui/button";
import { useAuth } from '../hooks/useAuth';
import axios from 'axios';
import LanguageSwitcher from './LanguageSwitcher';
import { useTranslation } from 'react-i18next';

export default function Header() {
  const { isAuthenticated, logout } = useAuth();
  const [isTeacher, setIsTeacher] = useState(false);
  const { t } = useTranslation('nav');
  const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8001';

  useEffect(() => {
    const checkTeacherStatus = async () => {
      if (!isAuthenticated) {
        setIsTeacher(false);
        return;
      }
      
      // First check localStorage for cached role
      const cachedRole = localStorage.getItem('faheem_role');
      if (cachedRole === 'teacher') {
        setIsTeacher(true);
        return;
      }
      
      // If not in cache, check with backend
      const token = localStorage.getItem('faheem_token');
      if (token) {
        try {
          const response = await axios.get(`${BACKEND_URL}/api/teacher/check`, {
            params: { access_token: token }
          });
          if (response.data?.is_teacher) {
            setIsTeacher(true);
            localStorage.setItem('faheem_role', 'teacher');
          } else {
            setIsTeacher(false);
          }
        } catch (err) {
          setIsTeacher(false);
        }
      }
    };
    
    checkTeacherStatus();
  }, [isAuthenticated, BACKEND_URL]);

  // Determine profile link based on role
  const profileLink = isTeacher ? '/teacher-profile' : '/profile';

  return (
    <nav className="border-b border-slate-100 bg-white/80 backdrop-blur-sm sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-6 py-4 flex justify-between items-center">
        <div className="flex items-center gap-2">
          <Link to="/">
            <img 
              src="https://customer-assets.emergentagent.com/job_java-mentor-bot/artifacts/o77zmx4s_Gemini_Generated_Image_q1uh1iq1uh1iq1uh.png" 
              alt="FaheemGPT Logo" 
              className="w-10 h-10 rounded-lg object-cover" 
            />
          </Link>
          <span className="text-xl font-bold tracking-tight">FaheemGPT <span className="text-slate-400 font-normal">{t('footer.tagline', 'Intelligent Tutoring Platform')}</span></span>
        </div>
        <div className="flex items-center gap-4">
          <Link to="/about">
            <Button variant="ghost" className="hidden md:flex text-slate-600 hover:text-blue-600">{t('about')}</Button>
          </Link>
          <Link to="/meet-founder">
            <Button variant="ghost" className="hidden md:flex text-slate-600 hover:text-blue-600">{t('meetFounder')}</Button>
          </Link>
          <Link to="/partners">
            <Button variant="ghost" className="hidden md:flex text-slate-600 hover:text-blue-600">{t('partners')}</Button>
          </Link>
          <Link to="/how-it-works">
            <Button variant="ghost" className="hidden md:flex text-slate-600 hover:text-blue-600">{t('howItWorks')}</Button>
          </Link>
          
          {isAuthenticated ? (
            <>
              <Link to={profileLink}>
                <Button variant="ghost" className="hidden md:flex text-slate-600 hover:text-blue-600">{t('profile')}</Button>
              </Link>
              <Button 
                variant="ghost" 
                className="hidden md:flex text-red-600 hover:text-red-700"
                onClick={logout}
              >
                {t('logout')}
              </Button>
            </>
          ) : (
            <Link to="/login">
              <Button variant="ghost" className="hidden md:flex text-blue-600">{t('login')}</Button>
            </Link>
          )}
          
          {/* Language Switcher */}
          <LanguageSwitcher />
        </div>
      </div>
    </nav>
  );
}
